import React, { useCallback, useMemo, useReducer } from 'react';
import { CollapsibleCell } from "../components/CollapsibleCell/CollapsibleCell.js";
import { jsx as _jsx } from "react/jsx-runtime";
function rowReducer(state, action) {
  switch (action.type) {
    case 'toggle':
      return {
        focus: null,
        open: state.open === action.payload ? null : action.payload
      };
    case 'focus':
      return {
        ...state,
        focus: state.focus === action.payload ? null : action.payload
      };
    default:
      return state;
  }
}
export function useHydratedColumns(columns, rowBody, hasBody, rowStateHandling) {
  const [localActiveRow, dispatch] = useReducer(rowReducer, {
    open: null,
    focus: null
  });
  const activeRow = rowStateHandling?.activeRow ?? localActiveRow;
  const toggleRow = useCallback(id => {
    if (rowStateHandling) {
      rowStateHandling.toggleRow(id);
    } else {
      dispatch({
        type: 'toggle',
        payload: id
      });
    }
  }, [rowStateHandling]);
  const focusRow = useCallback(id => {
    if (rowStateHandling) {
      rowStateHandling.focusRow(id);
    } else {
      dispatch({
        type: 'focus',
        payload: id
      });
    }
  }, [rowStateHandling]);
  const hydratedColumns = useMemo(() => {
    if (rowBody) {
      return [...columns, {
        name: '__body',
        header: () => '',
        width: '50px',
        cellRenderer: (data, id) => ({
          isVisible: hasBody ? hasBody(data, id) : true,
          content: /*#__PURE__*/_jsx(CollapsibleCell, {
            id: id,
            onClick: toggleRow
          })
        })
      }];
    }
    return columns;
  }, [rowBody, columns, hasBody, toggleRow]);
  return useMemo(() => ({
    activeRow,
    hydratedColumns,
    toggleRow,
    focusRow
  }), [activeRow, hydratedColumns, toggleRow, focusRow]);
}